import { Button as ISBJButton, Color, Modal, ModalBody, ModalHeader } from '@isbj-redesign/frontend-components'
import FehlerIcon from '@isbj-redesign/icons/FaExclamationTriangleSolid'
import AnfragenIcon from '@isbj-redesign/icons/FaFileExportSolid'
import React, { ReactNode, useCallback, useState } from 'react'
import { UseMutationOptions } from 'react-query'
import { WretcherResponse } from 'wretch'
import { MutationBereistellenProps, useMutationBereitstellen } from './Api'
import ModalActions from './ModalActions'
import SpinningButton from './SpinningButton'
import { Dokument, ErrorLike } from './types'

export type Props = {
    label?: string
    dokumente: Dokument[]
    dateiname?: string
    disabled?: boolean
    help?: ReactNode
    options?: UseMutationOptions<WretcherResponse, ErrorLike, MutationBereistellenProps>
}

export default function AnfragenButton({ dokumente, ...rest }: Props) {
    if (dokumente.some((it) => it.bereitstellung !== null)) return <MutationButton dokumente={dokumente} {...rest} disabled help="bereitgestellt" />
    if (dokumente.every((it) => !it.anfrage)) return <MutationButton dokumente={dokumente} {...rest} />
    if (dokumente.some((it) => it.anfrage?.status === 'ANGEFRAGT')) return <Angefragt />
    if (dokumente.some((it) => it.anfrage?.status === 'FEHLER')) return <Fehler dokumente={dokumente} />
    return null
}

function MutationButton({ label, dokumente, dateiname, disabled, options, help }: Props) {
    const { isLoading, isSuccess, mutate } = useMutationBereitstellen(options)
    const loading = isLoading || isSuccess

    return (
        <div className="d-inline-flex flex-column align-items-center">
            <SpinningButton
                icon={AnfragenIcon}
                label={loading ? 'Wird angefragt' : label || 'Anfragen'}
                color={Color.Primary}
                onClick={() => mutate({ dokumente, dateiname })}
                spinning={loading}
                outline={loading}
                disabled={disabled}
            />
            {help && <small>{help}</small>}
        </div>
    )
}

function Angefragt() {
    return <SpinningButton label="Wird angefragt" color={Color.Primary} outline spinning />
}

function Fehler({ dokumente }: Pick<Props, 'dokumente'>) {
    const [showModal, setShowModal] = useState(false)
    const closeModal = useCallback(() => setShowModal(false), [])

    return (
        <>
            <ISBJButton color={Color.Danger} onClick={() => setShowModal(true)}>
                <FehlerIcon className="mr-1" /> Fehler
            </ISBJButton>
            <Modal show={showModal} onClose={closeModal}>
                <ModalHeader title="Fehler bei der Bereitstellung" />
                <ModalBody>
                    {dokumente.map((dokument) => (
                        <p key={dokument.id}>{dokument.anfrage?.fehler}</p>
                    ))}
                    <ModalActions onClose={closeModal}>
                        <MutationButton dokumente={dokumente} label="Erneut anfragen" options={{ onSuccess: closeModal }} />
                    </ModalActions>
                </ModalBody>
            </Modal>
        </>
    )
}
